module.exports = __webpack_public_path__ + "img/map.55a04134.png";